<template>
  <div class="py-[120px] xl:py-[160px]">
    <div class="container">
      <SectionAboutHero />
      <SectionJoinUs />
      <SectionTrustedInfo />
      <SectionOurHistory />
      <SectionTeam />
      <SectionStartToday class="pb-[60px] xl:pb-[80px]" />
      <SectionAboutContactInfo />
    </div>
  </div>
</template>

<script setup lang="ts">
import SectionAboutHero from "@/modules/Landing/components/Section/AboutHero.vue";
import SectionJoinUs from "@/modules/Landing/components/Section/JoinUs.vue";
import SectionTrustedInfo from "@/modules/Landing/components/Section/TrustedInfo.vue";
import SectionOurHistory from "@/modules/Landing/components/Section/OurHistory.vue";
import SectionTeam from "@/modules/Landing/components/Section/Team.vue";
import SectionStartToday from "@/modules/Landing/components/Section/StartToday.vue";
import SectionAboutContactInfo from "@/modules/Landing/components/Section/AboutContactInfo.vue";
import { useHead } from "@vueuse/head";

useHead({
  title: "Welcome to Saraf Robot",
  meta: [
    {
      name: "description",
      content:
        "Saraf Robot transforms cryptocurrency trading by making it simple, efficient, and accessible for everyone. Our platform automates your trading strategies, enabling you to trade smartly and profitably, without constant manual input. Whether you are a beginner or an expert, Saraf Robot helps you get started with ease and efficiency.",
    },

    // Open Graph (OG) meta tags
    { property: "og:title", content: "Welcome to Saraf Robot" },
    {
      property: "og:description",
      content:
        "Saraf Robot transforms cryptocurrency trading by making it simple, efficient, and accessible for everyone. Our platform automates your trading strategies, enabling you to trade smartly and profitably, without constant manual input. Whether you are a beginner or an expert, Saraf Robot helps you get started with ease and efficiency.",
    },
    { property: "og:image", content: "/og-image.webp" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:width", content: "1200" },

    // Twitter meta tags
    { name: "twitter:card", content: "summary" },
    { name: "twitter:site", content: "@sarafrobot" },
    { name: "twitter:image", content: "/og-image.webp" },
  ],
  link: [{ rel: "canonical", href: "https://app.sarafrobot.com/about-us" }],
});
</script>

<style scoped></style>
